import React, { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { VideoLibrary } from "./VideoLibrary";
import { VideoLocked } from "./VideoLocked";
import { NewVideoForm } from "./NewVideoForm";
import { VideoEditor } from "./VideoEditor";

export const VideoPane = ({ project, initialVideo }) => {
  const [access, setAccess] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [list, setList] = useState(null);
  const [sel, setSel] = useState(initialVideo || null);

  const load = useCallback(() => api.videos(project.id).then(setList).catch(() => setList((l) => l || [])), [project.id]);
  useEffect(() => {
    api.videoAccess().then(setAccess).catch((e) => setAccess({ error: errMsg(e) }));
    api.videoPricing().then(setPricing).catch(() => {});
    load();
  }, [load]);
  useEffect(() => { if (list && !sel) setSel(list[0]?.id || "new"); }, [list, sel]);

  if (access?.error) return <p className="p-6 text-sm text-rose-600" data-testid="video-access-error">{access.error}</p>;
  if (!access || !list) return <div className="h-full flex items-center justify-center"><Loader2 className="animate-spin text-emerald-600" /></div>;
  if (!access.allowed) return <VideoLocked pricing={pricing} />;

  const created = (v) => { setSel(v.id); load(); };
  const deleted = () => { setSel(null); setList(null); load(); };

  return (
    <div className="h-full flex flex-col md:flex-row" data-testid="video-pane">
      <VideoLibrary list={list} sel={sel} onSelect={setSel} />
      <div className="flex-1 min-w-0 min-h-0">
        {sel === "new"
          ? <NewVideoForm projectId={project.id} pricing={pricing} onCreated={created} />
          : sel && <VideoEditor key={sel} vid={sel} pricing={pricing} onChanged={load} onDeleted={deleted} />}
      </div>
    </div>
  );
};

export default VideoPane;
